import {loadLayers} from '../../api/layers/layers.api';
import {loadFeatures} from '../../api/geosimepar/features.api';
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

const state = {
  layers: undefined,
  monitoringLayers: undefined,
  waterSupplyLayers: undefined,
  effluentsLayers: undefined,
  stationsDataLayers: undefined,
  conservationLayers: undefined,
  timeFeatures: undefined,
  indicatorsLayers: undefined,
  undergroundWaterLayers: undefined,
};

const mutations = {
  setMonitoringLayers(state, data) {
    state.monitoringLayers = data;
  },
  setIndicatorsLayers(state, data) {
    state.indicatorsLayers = data;
  },
  setUndergroundWaterLayers(state, data) {
    state.undergroundWaterLayers = data;
  },
  setWaterSupplyLayers(state, data) {
    state.waterSupplyLayers = data;
  },
  setEffluentsLayers(state, data) {
    state.effluentsLayers = data;
  },
  setConservationLayers(state, data) {
    state.conservationLayers = data;
  },
  setStationsDataLayers(state, data) {
    state.stationsDataLayers = data;
  },
  cleanLayers(state) {
    state.layers = undefined;
  },
  setTimeFeatures(state, data) {
    state.timeFeatures = data;
  },
  cleanTimeFeatures(state) {
    state.timeFeatures = undefined;
  },
};

const actions = {
  async loadMonitoringLayers({commit}) {
    try {
      const response = await loadLayers();
      commit('setMonitoringLayers', response.data['monitoring']);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações de monitoramento.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      
      commit('setMonitoringLayers', undefined);
    }
  },
  async loadWaterSupplyLayers({commit}) {
    try {
      const response = await loadLayers();
      commit('setWaterSupplyLayers', response.data['water_supply']);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações de fornecimento de água.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setWaterSupplyLayers', undefined);
    }
  },
  async loadEffluentsLayers({commit}) {
    try {
      const response = await loadLayers();
      commit('setEffluentsLayers', response.data['effluents']);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações dos efluentes.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setEffluentsLayers', undefined);
    }
  },
  async loadConservationLayers({commit}) {
    try {
      const response = await loadLayers();
      commit('setConservationLayers', response.data['conservation']);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações de conservação.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setConservationLayers', undefined);
    }
  },
  async loadStationsDataLayers({commit}) {
    try {
      const response = await loadLayers();
      commit('setStationsDataLayers', response.data['stations_data']);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações das estações.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setStationsDataLayers', undefined);
    }
  },
  async loadIndicatorsLayers({commit}) {
    try {
      const response = await loadLayers();
      commit('setIndicatorsLayers', response.data['indicators']);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações dos indicadores.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setIndicatorsLayers', undefined);
    }
  },
  async loadUndergroundWaterLayers({commit}) {
    try {
      const response = await loadLayers();
      commit('setUndergroundWaterLayers', response.data['undergroundWater']);
    } catch (error) {
      Vue.$toast.open({
        message: `Não foi possível carregar as informações das águas subterrâneas.`,
        type: "error",
        duration: 5000,
        dismissible: true
      });
      commit('setUndergroundWaterLayers', undefined);
    }
  },
  async loadTimeFeatures({commit}, payload) {
    const {url} = payload;

    try {
      const response = await loadFeatures(url);
      commit('setTimeFeatures', response.data);
    } catch (error) {
      commit('setTimeFeatures', undefined);
    }
  },
};

const getters = {
  monitoringLayers: (state) => state.monitoringLayers,
  waterSupplyLayers: (state) => state.waterSupplyLayers,
  effluentsLayers: (state) => state.effluentsLayers,
  conservationLayers: (state) => state.conservationLayers,
  stationsDataLayers: (state) => state.stationsDataLayers,
  timeFeatures: (state) => state.timeFeatures,
  indicatorsLayers: (state) => state.indicatorsLayers,
  undergroundWaterLayers: (state) => state.undergroundWaterLayers,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
